// Creates one durable Promotion Idea per event Auction item. Uses a transaction
// to reuse the idea across clicks, and copies only public item copy and images.
// Auction financial records, bidder data, and internal notes never enter drafts.
import { doc, runTransaction, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";
import { getEntryImageUrls } from "../../utils/entry_images";
import { hasPurchasedAddOn } from "../../utils/event_addons";
import { PROMOTION_ENGINE_SOURCES, PROMOTION_SCOPES } from "../config/promotion_settings_map";
import { PROMOTION_IDEA_STATUS } from "../constants/promotion_status";

export const getAuctionPromotionIdea = async ({ eventId, auctionItemId }) => {
  if (!eventId || !auctionItemId || eventId.includes("/") || auctionItemId.includes("/")) {
    throw new Error("A valid event and Auction item are required.");
  }
  // JSON encoding preserves tuple boundaries; URI encoding makes a safe document ID.
  const id = `auction_${encodeURIComponent(JSON.stringify([eventId, auctionItemId]))}`;
  const ideaRef = doc(db, "promotion_ideas", id);
  return runTransaction(db, async (transaction) => {
    const event = await transaction.get(doc(db, "events", eventId));
    const item = await transaction.get(doc(db, "events", eventId, "auctionItems", auctionItemId));
    const existing = await transaction.get(ideaRef);
    if (!event.exists() || !item.exists() || item.data().placeholder === true) {
      throw new Error("Auction item is unavailable.");
    }
    if (!hasPurchasedAddOn({ purchasedAddOns: event.data().purchasedAddOns }, "auction")) throw new Error("Auction is not enabled for this event.");
    if (existing.exists()) return { ...existing.data(), id };
    const data = item.data();
    let images = getEntryImageUrls(data);
    if (data.linkedEntryId && !data.linkedEntryId.includes("/")) {
      const entry = await transaction.get(doc(db, "events", eventId, "cars", data.linkedEntryId));
      const entryImages = entry.exists() ? getEntryImageUrls(entry.data()) : [];
      if (entryImages.length) images = entryImages;
    }
    const idea = {
      title: data.title || "Auction Item", description: data.description || "",
      category: "auction_item", requestType: "social_post", eventType: event.data().eventType || "",
      sourceAuctionItemId: auctionItemId, imageUrls: images,
      platforms: [], postTypes: [], scope: PROMOTION_SCOPES.EVENT, eventId,
      engineSource: PROMOTION_ENGINE_SOURCES.AUCTIONS, ideaStatus: PROMOTION_IDEA_STATUS.NEW,
      createdAt: serverTimestamp(), updatedAt: serverTimestamp(),
    };
    transaction.set(ideaRef, idea);
    return { ...idea, id };
  });
};
